"use client";

import { c as _c } from "react/compiler-runtime";
import Input, { InputProps } from "@/components/ui/input";
import { cx } from "@/lib/tailwind-utils";
interface InlineNameInputProps extends Omit<InputProps, "onChange"> {
  value: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  autoFocus?: boolean;
  readOnly?: boolean;
  hasError?: boolean;
  errorMessage?: string;
  className?: string;
}
export function InlineNameInput(t0) {
  const $ = _c(13);
  const {
    value,
    onChange,
    placeholder,
    autoFocus,
    readOnly,
    hasError,
    errorMessage,
    className
  } = t0;
  let t1;
  if ($[0] !== onChange) {
    t1 = e => onChange?.(e.target.value);
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== className) {
    t2 = cx("border-0 bg-transparent text-h1 shadow-none", "!ring-0 !outline-none p-0", "hover:!ring-1 hover:!ring-border hover:!outline-none", "w-min", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== autoFocus || $[5] !== errorMessage || $[6] !== hasError || $[7] !== placeholder || $[8] !== readOnly || $[9] !== t1 || $[10] !== t2 || $[11] !== value) {
    t3 = <div className="group flex items-center gap-1.5"><Input value={value} onChange={t1} placeholder={placeholder} autoFocus={autoFocus} readOnly={readOnly} hasError={hasError} errorMessage={errorMessage} className={t2} /></div>;
    $[4] = autoFocus;
    $[5] = errorMessage;
    $[6] = hasError;
    $[7] = placeholder;
    $[8] = readOnly;
    $[9] = t1;
    $[10] = t2;
    $[11] = value;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}